import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFormData } from 'Services/Features/Branch/branchSlice';
import { getTreatment } from 'Services/Features/Treatment/Utils/treatmentUtils'

const SelectTreatment = () => {
    const dispatch = useDispatch();
    const treatment = useSelector(state => state.branch.currentBranch.treatment);

    const filter = useSelector(state => state.treatment.filters);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleChangeCategory = (selectedOption) => {
        console.log(selectedOption, 'selectedOption');
        setSelectedValue(selectedOption === null ? [] : selectedOption);
        dispatch(setFormData({ treatment_id: selectedOption === null ? [] : selectedOption.map(item => item.value) }));
    };

    useEffect(() => {
        const selectedTreatment = treatment?.length > 0 ? treatment.map(item => ({
            value: item.id,
            label: item.name,
        })) : selectedValue;
        setSelectedValue(selectedTreatment);
        dispatch(setFormData({ treatment_id: treatment?.length > 0 ? treatment.map(item => item.id) : [] }));
    }, []);

    const promiseOptionCategory = (inputValue, callback) => {
        dispatch(getTreatment({
            ...filter,
            'filter[name]': inputValue,
            'sort': 'name',
            'page': 1,
        }))
            .then((response) => {
                const options = response.payload.data.map(item => ({
                    value: item.id,
                    label: item.name,
                }));
                callback(options);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
                callback([]);
            });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptionCategory}
            handleChange={(selectedOption) => handleChangeCategory(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Layanan"
            isMulti={true}
        />
    )
}

export default SelectTreatment;
